import { render, staticRenderFns } from "./LessonManager.vue?vue&type=template&id=44bd2a54&scoped=true&"
import script from "./LessonManager.vue?vue&type=script&lang=js&"
export * from "./LessonManager.vue?vue&type=script&lang=js&"
import style0 from "./LessonManager.vue?vue&type=style&index=0&id=44bd2a54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bd2a54",
  null
  
)

export default component.exports